import { CustomObject } from '../../types';
import { MODULE_PATHS } from '../../utils/const';
import { PageTypeId } from '../toolNavigationBuilder/const';

const lowerCased = (obj: CustomObject) =>
	Object.entries(obj).reduce((result, [key, value]) => {
		result[key.toLowerCase()] = value;

		return result;
	}, {});

const PATH_TO_PAGE_TYPE_ID_MAP = lowerCased({
	[MODULE_PATHS.activityList]: PageTypeId.ActivityList,
	[MODULE_PATHS.activityTaskList]: PageTypeId.TaskList,
	[MODULE_PATHS.agencyList]: PageTypeId.AgencyList,
	[MODULE_PATHS.agencyCommonDetails]: PageTypeId.AgencyDetails,
	[MODULE_PATHS.structure]: PageTypeId.AgencyStructure,
	[MODULE_PATHS.allJobs]: PageTypeId.PublicJobAllJobs,
	[MODULE_PATHS.apiUserCommonDetails]: PageTypeId.ConnectApiUserDetails,
	[MODULE_PATHS.apiUserList]: PageTypeId.ConnectApiUserList,
	[MODULE_PATHS.applicationForm]: PageTypeId.ApplicationForm,
	[MODULE_PATHS.applicationsCommonDetails]: PageTypeId.ApplicationDetails,
	[MODULE_PATHS.applicationsList]: PageTypeId.ApplicationList,
	[MODULE_PATHS.auditTrailList]: PageTypeId.AuditTrailList,
	[MODULE_PATHS.automationDetails]: PageTypeId.AutomationDetails,
	[MODULE_PATHS.automationList]: PageTypeId.AutomationList,
	[MODULE_PATHS.automationLogList]: PageTypeId.AutomationLogList,
	[MODULE_PATHS.calculationSchemeDetails]: PageTypeId.CalculationSchemeDetail,
	[MODULE_PATHS.calculationSchemeList]: PageTypeId.CalculationSchemeList,
	[MODULE_PATHS.candidateChangeList]: PageTypeId.CandidateChangeList,
	[MODULE_PATHS.candidateCommonDetailsNew]: PageTypeId.CandidateDetails,
	[MODULE_PATHS.candidateList]: PageTypeId.CandidateList,
	[MODULE_PATHS.candidatePensionList]: PageTypeId.PensionList,
	[MODULE_PATHS.candidateStatusMappingList]: PageTypeId.CandidateCandidateStatusMapping,
	[MODULE_PATHS.caoList]: PageTypeId.CaoList,
	[MODULE_PATHS.caoDetails]: PageTypeId.CaoCommonDetails,
	[MODULE_PATHS.caoListInstance]: PageTypeId.CaoInstanceList,
	[MODULE_PATHS.caoInstanceDetails]: PageTypeId.CaoInstanceCommonDetails,
	[MODULE_PATHS.caoNewsList]: PageTypeId.CaoNewsList,
	[MODULE_PATHS.caoNewsDetail]: PageTypeId.CaoNewsDetails,
	[MODULE_PATHS.caoWagesList]: PageTypeId.CaoWagesList,
	[MODULE_PATHS.caoWagesRequestList]: PageTypeId.CaoWagesRequestsList,
	[MODULE_PATHS.caoWagesRequestDetails]: PageTypeId.CaoWagesRequestsDetails,
	[MODULE_PATHS.clockwiseList]: PageTypeId.TimecardList,
	[MODULE_PATHS.clockwiseDetail]: PageTypeId.TimecardDetail,
	[MODULE_PATHS.commentsList]: PageTypeId.CommentList,
	[MODULE_PATHS.communitiesList]: PageTypeId.CommunitiesList,
	[MODULE_PATHS.communitiesCommonDetails]: PageTypeId.CommunitiesDetails,
	[MODULE_PATHS.componentModelList]: PageTypeId.ComponentModelList,
	[MODULE_PATHS.componentModelDetail]: PageTypeId.ComponentModelDetails,
	[MODULE_PATHS.connectDashboardList]: PageTypeId.ConnectDashboard,
	[MODULE_PATHS.connectSettings]: PageTypeId.ConnectSettings,
	[MODULE_PATHS.connectorList]: PageTypeId.ConnectorList,
	[MODULE_PATHS.connectorDetail]: PageTypeId.ConnectorDetails,
	[MODULE_PATHS.contactPersonList]: PageTypeId.EmployerContactPersonsList,
	[MODULE_PATHS.contactPersonDetail]: PageTypeId.EmployerContactpersonDetails,
	[MODULE_PATHS.contractsList]: PageTypeId.ContractList,
	[MODULE_PATHS.contractCommonDetails]: PageTypeId.ContractDetails,
	[MODULE_PATHS.contractsUpdateList]: PageTypeId.ContractBulkUpdateRequestList,
	[MODULE_PATHS.contractsUpdateDetail]: PageTypeId.ContractBulkUpdateDetails,
	[MODULE_PATHS.customCaoInstanceList]: PageTypeId.CustomCaoInstanceList,
	[MODULE_PATHS.customCaoInstanceDetails]: PageTypeId.CustomCaoInstanceCommonDetails,
	[MODULE_PATHS.customCaoList]: PageTypeId.CustomCaoList,
	[MODULE_PATHS.customCaoDetails]: PageTypeId.CustomCaoCommonDetails,
	[MODULE_PATHS.customerInvoiceComponentList]: PageTypeId.InvoiceComponentsList,
	[MODULE_PATHS.customerInvoiceList]: PageTypeId.CustomerInvoiceList,
	[MODULE_PATHS.customerInvoiceDetails]: PageTypeId.CustomerInvoiceDetails,
	[MODULE_PATHS.customerList]: PageTypeId.CustomerList,
	[MODULE_PATHS.customerDetails]: PageTypeId.CustomerCustomerDetails,
	[MODULE_PATHS.customerSubscriptionsList]: PageTypeId.CustomerSubscriptionList,
	[MODULE_PATHS.customerSubscriptionsDetails]: PageTypeId.CustomerSubscriptionDetails,
	[MODULE_PATHS.dashboard]: PageTypeId.Dashboard,
	[MODULE_PATHS.managementInformation]: PageTypeId.ManagementInformation,
	[MODULE_PATHS.dealsList]: PageTypeId.DealList,
	[MODULE_PATHS.dealsCommonDetails]: PageTypeId.DealDetails,
	[MODULE_PATHS.documentList]: PageTypeId.DocumentList,
	[MODULE_PATHS.documentSettingsList]: PageTypeId.DocumentSettingsList,
	[MODULE_PATHS.documentSettingsDetail]: PageTypeId.DocumentSettingsDetails,
	[MODULE_PATHS.documentTemplateList]: PageTypeId.DocumentTemplateList,
	[MODULE_PATHS.documentTemplateDetails]: PageTypeId.DocumentTemplateDetails,
	'/domainvalue/caoMapping': PageTypeId.DomainValuesCAOMapping, //todo: replace with MODULE_PATHS property when detail is moved to react
	[MODULE_PATHS.domainValueList]: PageTypeId.DomainValuesList,
	[MODULE_PATHS.domainValueDetail]: PageTypeId.DomainValuesDetails,
	[MODULE_PATHS.domainValueMappingList]: PageTypeId.DomainValuesMapping,
	[MODULE_PATHS.emailSenderAuthList]: PageTypeId.ConnectEmailSenderAuthList,
	[MODULE_PATHS.emailSenderAuthCommonDetails]: PageTypeId.ConnectEmailSenderAuthDetails,
	[MODULE_PATHS.employerList]: PageTypeId.EmployerList,
	[MODULE_PATHS.employerCommonDetails]: PageTypeId.EmployerDetails,
	[MODULE_PATHS.flexNetCustomerList]: PageTypeId.FlexNetCustomerList,
	[MODULE_PATHS.flexNetCustomerDetail]: PageTypeId.FlexNetCustomerDetails,
	[MODULE_PATHS.flexNetHostList]: PageTypeId.FlexNetHostList,
	[MODULE_PATHS.flexNetHostDetail]: PageTypeId.FlexNetHostDetails,
	[MODULE_PATHS.flexNetHostSettingsDetail]: PageTypeId.FlexNetHostSettings,
	[MODULE_PATHS.formList]: PageTypeId.FormUserList,
	[MODULE_PATHS.formCommonDetails]: PageTypeId.FormUserDetails,
	[MODULE_PATHS.formDesignerList]: PageTypeId.FormDesignerList,
	[MODULE_PATHS.formDesignerDetail]: PageTypeId.FormDesignerDetails,
	[MODULE_PATHS.formPublicViaLink]: PageTypeId.FormDesignerDetails,
	[MODULE_PATHS.formPublic]: PageTypeId.FormPublic,
	[MODULE_PATHS.fsApiLogList]: PageTypeId.ConnectFSApiLogList,
	[MODULE_PATHS.illnessList]: PageTypeId.IllnessList,
	[MODULE_PATHS.illnessCommonDetails]: PageTypeId.IllnessDetails,
	[MODULE_PATHS.incomingMessageList]: PageTypeId.ConnectIncomingList,
	[MODULE_PATHS.incomingMessage]: PageTypeId.ConnectIncomingDetails,
	[MODULE_PATHS.incomingMessageLogList]: PageTypeId.ConnectIncomingLogList,
	[MODULE_PATHS.invoiceList]: PageTypeId.InvoiceList,
	[MODULE_PATHS.jobBoardList]: PageTypeId.ShareJobBoardList,
	[MODULE_PATHS.jobBoardDetails]: PageTypeId.ShareJobBoardDetails,
	[MODULE_PATHS.jobBoardInstanceList]: PageTypeId.ShareJobBoardInstanceList,
	[MODULE_PATHS.jobBoardInstanceDetail]: PageTypeId.ShareJobBoardInstanceDetails,
	[MODULE_PATHS.jobList]: PageTypeId.JobList,
	[MODULE_PATHS.jobCommonDetails]: PageTypeId.JobDetails,
	[MODULE_PATHS.jobPostList]: PageTypeId.ShareJobPostList,
	[MODULE_PATHS.jobPostDetail]: PageTypeId.ShareJobPostDetails,
	[MODULE_PATHS.labelList]: PageTypeId.LabelList,
	[MODULE_PATHS.labelDetails]: PageTypeId.LabelLabelDetails,
	[MODULE_PATHS.modelMatrixList]: PageTypeId.ModelMatrixList,
	[MODULE_PATHS.modelMatrixDetail]: PageTypeId.ModelMatrixDetails,
	[MODULE_PATHS.modelMatrixInstanceList]: PageTypeId.ModelMatrixInstanceList,
	[MODULE_PATHS.modelMatrixInstanceDetail]: PageTypeId.ModelMatrixInstanceDetails,
	[MODULE_PATHS.newsadminList]: PageTypeId.NewsAdminList,
	[MODULE_PATHS.newsAdminCommonDetails]: PageTypeId.NewsAdminDetails,
	[MODULE_PATHS.newsList]: PageTypeId.NewsList,
	[MODULE_PATHS.newsCommonDetails]: PageTypeId.NewsDetails,
	[MODULE_PATHS.optOutList]: PageTypeId.SurveyListOptOutList,
	[MODULE_PATHS.outgoingMessageList]: PageTypeId.ConnectOutgoingList,
	[MODULE_PATHS.outgoingMessageDetails]: PageTypeId.ConnectOutgoingDetails,
	[MODULE_PATHS.outgoingMessageLogList]: PageTypeId.ConnectOutgoingLogList,
	[MODULE_PATHS.pageList]: PageTypeId.LabelPagesList,
	[MODULE_PATHS.pageDetails]: PageTypeId.LabelPageDetails,
	[MODULE_PATHS.paymentList]: PageTypeId.PaymentList,
	[MODULE_PATHS.payslipList]: PageTypeId.PayslipList,
	[MODULE_PATHS.payslipsCommonDetails]: PageTypeId.PayslipDetails,
	[MODULE_PATHS.periodicComponentsList]: PageTypeId.CandidatePeriodicComponentsList,
	[MODULE_PATHS.phaseList]: PageTypeId.CandidatePhaseList,
	[MODULE_PATHS.proformaList]: PageTypeId.ProformaList,
	[MODULE_PATHS.proformaDetails]: PageTypeId.ProformaDetail,
	[MODULE_PATHS.publicDocumentAuthentication]: PageTypeId.PublicDocumentLogin,
	[MODULE_PATHS.publicDocumentList]: PageTypeId.PublicDocumentList,
	[MODULE_PATHS.publicEmployerList]: PageTypeId.PublicEmployerEmployerList,
	[MODULE_PATHS.publicEmployerDetail]: PageTypeId.PublicEmployerEmployerDetails,
	[MODULE_PATHS.publicJobApply]: PageTypeId.PublicJobApply,
	[MODULE_PATHS.publicJobList]: PageTypeId.PublicJobJobList,
	[MODULE_PATHS.publicJobDetail]: PageTypeId.PublicJobJobDetails,
	[MODULE_PATHS.publicNewsList]: PageTypeId.NewsPublicNewsList,
	[MODULE_PATHS.publicNewsDetail]: PageTypeId.NewsPublicNewsDetails,
	[MODULE_PATHS.purchaseInvoiceList]: PageTypeId.InvoicePurchaseInvoice,
	[MODULE_PATHS.rateClassList]: PageTypeId.RateClassesList,
	[MODULE_PATHS.rateClassDetail]: PageTypeId.RateClassesDetails,
	[MODULE_PATHS.reservationList]: PageTypeId.CandidateReservationList,
	[MODULE_PATHS.rolesList]: PageTypeId.RoleList,
	[MODULE_PATHS.rolesCommonDetails]: PageTypeId.RoleDetails,
	[MODULE_PATHS.safetyList]: PageTypeId.SafetyList,
	[MODULE_PATHS.savedFilterAdminList]: PageTypeId.SavedFilterSystemFiltersList,
	[MODULE_PATHS.savedFilterLogsList]: PageTypeId.SavedFilterAlertLogsList,
	[MODULE_PATHS.savedFilterMyList]: PageTypeId.SavedFilterMyFiltersList,
	[MODULE_PATHS.savedFilterOwnList]: PageTypeId.SavedFilterOtherUsersFiltersList,
	[MODULE_PATHS.settingList]: PageTypeId.SettingList,
	[MODULE_PATHS.shareLogList]: PageTypeId.ShareLogList,
	[MODULE_PATHS.shareLogDetail]: PageTypeId.ShareLogDetails,
	[MODULE_PATHS.subscriberList]: PageTypeId.SubscriberList,
	[MODULE_PATHS.subscriptionSettingList]: PageTypeId.CustomerSubscriptionSettingList,
	[MODULE_PATHS.subscriptionSettingDetails]: PageTypeId.CustomerSubscriptionSettingDetails,
	[MODULE_PATHS.suppliersList]: PageTypeId.SupplierOrganizationList,
	[MODULE_PATHS.supportAccessList]: PageTypeId.ConnectCustomerAccessRequestList,
	[MODULE_PATHS.surveyAdminList]: PageTypeId.SurveyAdminList,
	[MODULE_PATHS.surveyAdminDetails]: PageTypeId.SurveyAdminDetails,
	[MODULE_PATHS.surveyList]: PageTypeId.SurveyList,
	[MODULE_PATHS.surveyCommonDetails]: PageTypeId.SurveyDetails,
	[MODULE_PATHS.tagList]: PageTypeId.TagList,
	[MODULE_PATHS.templateList]: PageTypeId.LabelTemplates,
	[MODULE_PATHS.templateDetails]: PageTypeId.LabelTemplateDetails,
	[MODULE_PATHS.testCalculationScheme]: PageTypeId.CalculationSchemeClockwiseTest,
	[MODULE_PATHS.textModelList]: PageTypeId.TextModelList,
	[MODULE_PATHS.textModelDetails]: PageTypeId.TextModelDetails,
	[MODULE_PATHS.translationList]: PageTypeId.LabelTranslations,
	[MODULE_PATHS.translationDetails]: PageTypeId.TranslationsDetails,
	[MODULE_PATHS.userList]: PageTypeId.UserList,
	[MODULE_PATHS.userCommonDetails]: PageTypeId.UserDetails,
	[MODULE_PATHS.userProfile]: PageTypeId.UserProfile,
	[MODULE_PATHS.wmlList]: PageTypeId.CaoWmlList,
	[MODULE_PATHS.wmlDetails]: PageTypeId.CaoWmlDetails,
	[MODULE_PATHS.backofficeActionPage]: PageTypeId.BackofficeIndex,
	[MODULE_PATHS.journalTransferFilesList]: PageTypeId.BackofficeJournalTransferFilesList,
	[MODULE_PATHS.backofficeProcessingList]: PageTypeId.BackofficeProcessingList,
	[MODULE_PATHS.backofficePaymentTransferFilesList]: PageTypeId.BackofficePaymentTransferFilesList,
});

const DETAIL_TO_LIST_PAGE_TYPE_ID_MAP = {
	[PageTypeId.AgencyDetails]: PageTypeId.AgencyList,
	[PageTypeId.ConnectApiUserDetails]: PageTypeId.ConnectApiUserList,
	[PageTypeId.ApplicationDetails]: PageTypeId.ApplicationList,
	[PageTypeId.AutomationDetails]: PageTypeId.AutomationList,
	[PageTypeId.CalculationSchemeDetail]: PageTypeId.CalculationSchemeList,
	[PageTypeId.CandidateDetails]: PageTypeId.CandidateList,
	[PageTypeId.CaoCommonDetails]: PageTypeId.CaoList,
	[PageTypeId.CaoInstanceCommonDetails]: PageTypeId.CaoInstanceList,
	[PageTypeId.CaoNewsDetails]: PageTypeId.CaoNewsList,
	[PageTypeId.CaoWagesRequestsDetails]: PageTypeId.CaoWagesRequestsList,
	[PageTypeId.TimecardDetail]: PageTypeId.TimecardList,
	[PageTypeId.CommunitiesDetails]: PageTypeId.CommunitiesList,
	[PageTypeId.ComponentModelDetails]: PageTypeId.ComponentModelList,
	[PageTypeId.ConnectorDetails]: PageTypeId.ConnectorList,
	[PageTypeId.EmployerContactpersonDetails]: PageTypeId.EmployerContactPersonsList,
	[PageTypeId.ContractDetails]: PageTypeId.ContractList,
	[PageTypeId.ContractBulkUpdateDetails]: PageTypeId.ContractBulkUpdateRequestList,
	[PageTypeId.CustomCaoInstanceCommonDetails]: PageTypeId.CustomCaoInstanceList,
	[PageTypeId.CustomCaoCommonDetails]: PageTypeId.CustomCaoList,
	[PageTypeId.CustomerInvoiceDetails]: PageTypeId.CustomerInvoiceList,
	[PageTypeId.CustomerCustomerDetails]: PageTypeId.CustomerList,
	[PageTypeId.CustomerSubscriptionDetails]: PageTypeId.CustomerSubscriptionList,
	[PageTypeId.DealDetails]: PageTypeId.DealList,
	[PageTypeId.DocumentSettingsDetails]: PageTypeId.DocumentSettingsList,
	[PageTypeId.DocumentTemplateDetails]: PageTypeId.DocumentTemplateList,
	[PageTypeId.DomainValuesDetails]: PageTypeId.DomainValuesList,
	[PageTypeId.ConnectEmailSenderAuthDetails]: PageTypeId.ConnectEmailSenderAuthList,
	[PageTypeId.EmployerDetails]: PageTypeId.EmployerList,
	[PageTypeId.FlexNetCustomerDetails]: PageTypeId.FlexNetCustomerList,
	[PageTypeId.FlexNetHostDetails]: PageTypeId.FlexNetHostList,
	[PageTypeId.FormUserDetails]: PageTypeId.FormUserList,
	[PageTypeId.FormDesignerDetails]: PageTypeId.FormDesignerList,
	[PageTypeId.IllnessDetails]: PageTypeId.IllnessList,
	[PageTypeId.ConnectIncomingDetails]: PageTypeId.ConnectIncomingList,
	[PageTypeId.ShareJobBoardDetails]: PageTypeId.ShareJobBoardList,
	[PageTypeId.ShareJobBoardInstanceDetails]: PageTypeId.ShareJobBoardInstanceList,
	[PageTypeId.JobDetails]: PageTypeId.JobList,
	[PageTypeId.ShareJobPostDetails]: PageTypeId.ShareJobPostList,
	[PageTypeId.LabelLabelDetails]: PageTypeId.LabelList,
	[PageTypeId.ModelMatrixDetails]: PageTypeId.ModelMatrixList,
	[PageTypeId.ModelMatrixInstanceDetails]: PageTypeId.ModelMatrixInstanceList,
	[PageTypeId.NewsAdminDetails]: PageTypeId.NewsAdminList,
	[PageTypeId.NewsDetails]: PageTypeId.NewsList,
	[PageTypeId.ConnectOutgoingDetails]: PageTypeId.ConnectOutgoingList,
	[PageTypeId.LabelPageDetails]: PageTypeId.LabelPagesList,
	[PageTypeId.PayslipDetails]: PageTypeId.PayslipList,
	[PageTypeId.ProformaDetail]: PageTypeId.ProformaList,
	[PageTypeId.PublicEmployerEmployerDetails]: PageTypeId.PublicEmployerEmployerList,
	[PageTypeId.PublicJobJobDetails]: PageTypeId.PublicJobJobList,
	[PageTypeId.NewsPublicNewsDetails]: PageTypeId.NewsPublicNewsList,
	[PageTypeId.RateClassesDetails]: PageTypeId.RateClassesList,
	[PageTypeId.RoleDetails]: PageTypeId.RoleList,
	[PageTypeId.ShareLogDetails]: PageTypeId.ShareLogList,
	[PageTypeId.CustomerSubscriptionSettingDetails]: PageTypeId.CustomerSubscriptionSettingList,
	[PageTypeId.SurveyAdminDetails]: PageTypeId.SurveyAdminList,
	[PageTypeId.SurveyDetails]: PageTypeId.SurveyList,
	[PageTypeId.LabelTemplateDetails]: PageTypeId.LabelTemplates,
	[PageTypeId.TextModelDetails]: PageTypeId.TextModelList,
	[PageTypeId.TranslationsDetails]: PageTypeId.LabelTranslations,
	[PageTypeId.UserDetails]: PageTypeId.UserList,
	[PageTypeId.CaoWmlDetails]: PageTypeId.CaoWmlList,
};

export { PATH_TO_PAGE_TYPE_ID_MAP, DETAIL_TO_LIST_PAGE_TYPE_ID_MAP };
